// src/sql/GetSnapDeck.jsx
import React, { useEffect, useState } from "react";
import axios from "axios";

function GetSnapDeck({ deckId, onClose }) {
  const [deck, setDeck] = useState(null);

  useEffect(() => {
    const fetchDeck = async () => {
      try {
        const res = await axios.get(`${process.env.REACT_APP_API_URL}api/data/snapDecks/${deckId}`);
        setDeck(res.data);
      } catch (err) {
        console.error("Failed to fetch deck:", err);
      }
    };
    fetchDeck();
  }, [deckId]);

  if (!deck) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <h2 style={{ textAlign: "center" }}>{deck.deckName}</h2>
        <p style={{ textAlign: "center" }}>
           Version: {deck.versionNum || "N/A"} | Rank: {deck.deckRank || "N/A"} | Month: {deck.monthCompleted || "N/A"} | 
           Ranking: {deck.deckRanking ?? "Unranked"}
        </p>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(3, 1fr)", gap: "8px" }}>
          {[...Array(12)].map((_, i) => (
            <div key={i} style={{ background: "#222", borderRadius: "6px", padding: "4px" }}>
              Card {i + 1}: {deck[`card${i + 1}`] || "Empty"}
            </div>
          ))}
        </div>
        <div style={{ textAlign: "center", marginTop: "10px" }}>
          <button className="button" onClick={onClose}>Close</button>
        </div>
      </div>
    </div>
  );
}

export default GetSnapDeck;
